$(document).on("click", ".acc_ctrl", function (e) {
  e.preventDefault();
  
  var $clickedButton = $(this);
  
  // Don't do anything if this button has no content
  if ($clickedButton.hasClass("no-content")) {
    return;
  }
  
  var $clickedPanel = $clickedButton.next();
  
  if ($clickedButton.hasClass("active")) {
    // If clicked tab is already active, close it
    $clickedButton.removeClass("active");
    $clickedPanel.stop().slideUp(300);
  } else {
    // Close all other active tabs first
    var $activeButtons = $(".acc_ctrl.active");
    var $activePanels = $activeButtons.next();
    $activeButtons.removeClass("active");
    $activePanels.stop().slideUp(300);
    
    // Then open the clicked tab
    $clickedButton.addClass("active");
    $clickedPanel.stop().slideDown(300);
  }
});